import { Pagination } from "antd";

const PaginationList = ({
  pagination,
  setPagination,
  sizeChanger = true,
  pageSizeOptions = [10, 20, 50, 100],
}) => {
  const onChange = (newPage, newPageSize) => {
    setPagination({
      ...pagination,
      page: newPage,
      rowsPerPage: newPageSize,
    });
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "20px",
      }}
    >
      <Pagination
        showSizeChanger={sizeChanger}
        onChange={onChange}
        current={pagination.page}
        total={pagination.totalRows}
        pageSize={pagination.rowsPerPage}
        pageSizeOptions={pageSizeOptions}
      />
    </div>
  );
};

export default PaginationList;
